/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseDocumentsLanguageViewModel } from "../types/CourseDocumentsLanguageViewModel.ts";
import { eComLangSchema } from "./eComLangSchema.ts";

export const courseDocumentsLanguageViewModelSchema = z.object({
  id: z.optional(
    z.number().int().describe("ID do conteúdo do documento no idioma."),
  ),
  documentId: z.optional(
    z.number().int().describe("ID do documento-modelo dono do conteúdo."),
  ),
  eComCultureInfo: z.optional(
    z
      .lazy(() => eComLangSchema)
      .describe(
        "1 = ptBR | 2 = esES | 3 = enUS | 4 = frFR | 5 = arAE | 6 = ruRU | 7 = zhHans | 8 = bgBG | 9 = csCZ | 10 = daDK | 11 = deDE | 12 = elGR | 13 = etEE | 14 = fiFI | 15 = hrHR | 16 = trTR | 17 = huHU | 18 = itIT | 19 = ltLT | 20 = lvLV | 21 = nlNL | 22 = plPL | 23 = roRO | 24 = skSK | 25 = slSI | 26 = svSE | ",
      ),
  ),
  cultureInfo: z
    .string()
    .describe("Cultura correspondente ao idioma.")
    .nullish(),
  documentName: z.string().describe("Nome do documento no idioma.").nullish(),
  documentHtml: z
    .string()
    .describe(
      "Conteúdo da declaração no idioma, com os marcadores de substituição do legado. ATENÇÃO: o valor trafega HTML-encoded, exatamente como está gravado na base (as tags chegam como &lt;div&gt;), porque é assim que o renderizador da declaração espera recebê-lo. O consumidor precisa decodificar para exibir ou editar, e enviar de volta codificado. Nulo quando a declaração é do tipo arquivo. Opcional.",
    )
    .nullish(),
  filePath: z
    .string()
    .describe(
      "Caminho do arquivo PDF da declaração no storage, quando a declaração é do tipo arquivo. Opcional.",
    )
    .nullish(),
  isEditable: z.optional(
    z
      .boolean()
      .describe(
        "Indica se este idioma pode ser enviado de volta na atualização. Declarações aceitam apenas pt-BR, en-US e es-ES; os demais idiomas do documento vêm somente para leitura.",
      ),
  ),
}) as unknown as ToZod<CourseDocumentsLanguageViewModel>;
